<template lang="html">
  <div v-if="students" class="row">
    <div class="col-12">
      <article class="fc-m-container">
        <h2>Students</h2>
        <form class="fc-a-search" @submit="searchStudents">
          <input
            class="form-control fc-a-search__input"
            type="text"
            placeholder="Search students by username"
            v-model="search"
          />
          <button type="submit" name="button" class="btn btn-primary">
            Search
          </button>
        </form>

        <table class="table table-striped">
          <thead>
            <th scope="col"></th>
            <th scope="col">Username</th>
            <th scope="col">Leagues</th>
            <th scope="col" class="d-none d-md-table-cell">Teams</th>
          </thead>
          <!-- list students -->
          <tbody v-if="students">
            <tr v-for="student in students" :key="student.id">
              <td class="">
                <input
                  type="checkbox"
                  v-model="checkedStudents"
                  v-bind:value="student.id"
                />
              </td>
              <td>
                <router-link :to="`/students/${student.id}`">
                  {{ student.username }}
                </router-link>
              </td>
              <td>
                <div v-for="league in student.leagues" :key="league.id">
                  <router-link :to="`/leagues/${league.id}`">{{
                    league.name
                  }}</router-link>
                </div>
              </td>
              <td class="d-none d-md-table-cell">
                <div
                  v-for="league in student.leagues"
                  :key="league.id"
                  :set="(team = checkForTeam(league.teams, student.id))"
                >
                  <router-link
                    v-if="team"
                    :to="`/leagues/${league.id}/teams/${team.id}`"
                    >{{ team.name }}</router-link
                  >
                  <span v-else>&nbsp;</span>
                </div>
              </td>
            </tr>
            <tr v-if="!students.length">
              <td></td>
              <td colspan="3">No students to display.</td>
            </tr>
          </tbody>
          <!-- loader -->
          <tbody v-else>
            <tr>
              <td colspan="4">
                <loader v-bind:embeded="true"></loader>
              </td>
            </tr>
          </tbody>
        </table>
        <pagination
          v-if="studentsPrevious || studentsNext"
          v-bind:next="studentsNext"
          v-bind:previous="studentsPrevious"
          @newPage="getStudents"
        ></pagination>

        <div v-if="students.length" class="row mt-4 p-0">
          <div class="col-12 col-md-8 col-lg-4">
            <div class="form-group">
              <label for="name">Update selected students:</label>
              <select required class="form-control" name="draft_type">
                <option disabled value="">Please select an option:</option>
                <option value="remove">Remove students</option>
              </select>
            </div>
            <button
              @click="editMultipleStudents"
              type="button"
              name="button"
              class="btn btn-primary"
            >
              Submit
            </button>
          </div>
        </div>
      </article>
    </div>
    <div class="col-12 col-lg-6">
      <article class="fc-m-container">
        <h2>Sign Up Page</h2>
        <p>
          Allow students to create accounts using your sign up page. In order to
          register, students must enter a username, password, and your account
          (or league) passphrase.
        </p>
        <div class="">
          Your sign up link:
        </div>
        <p class="alert alert-info">
          <a :href="signupLink" style="color:inherit">{{ signupLink }}</a>
        </p>
        <div class="">
          Account Passphrase:
        </div>
        <p class="alert alert-success">
          <b>{{ passphrase }}</b>
        </p>
        <form class="" @submit="updatePassphrase">
          <div class="form-group">
            <label for="passphrase">Update Passphrase:</label>
            <input
              v-model="updatedPassphrase"
              type="text"
              class="form-control"
              name="passphrase"
              value=""
            />
            <p class="small">
              Enter a new passphrase for your account. Minimum of 10 characters.
              Only alphanumeric and special characters !, @, #, $, and % are
              allowed. Passphrase is case sensitive.
            </p>
          </div>
          <button type="submit" class="btn btn-primary" name="button">
            Submit
          </button>
        </form>
      </article>
    </div>
    <div class="col-12 col-lg-6">
      <article class="fc-m-container">
        <h2>Add Student</h2>
        <p>Manually create an account for a student.</p>
        <form class="" @submit="createStudent">
          <div class="form-row">
            <div class="form-group col-12 ">
              <label for="username">Username </label>
              <input
                v-model="username"
                class="form-control"
                type="text"
                name="username"
                value=""
              />
            </div>
            <div class="form-group col-12 ">
              <label for="password1">Password </label>
              <input
                v-model="password1"
                class="form-control"
                type="password"
                name="password1"
                value=""
              />
            </div>
            <div class="form-group col-12 ">
              <label for="password2">Confirm Password </label>
              <input
                v-model="password2"
                class="form-control"
                type="password"
                name="password2"
                value=""
              />
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-12">
              <loader v-if="submitted" v-bind:embeded="true"></loader>
              <button v-else type="submit" class="btn btn-primary">
                Add
              </button>
            </div>
          </div>
        </form>
      </article>
    </div>
  </div>
  <loader v-else v-bind:embeded="false"></loader>
</template>

<script>
import Pagination from "@/views/components/Pagination";
import Loader from "@/views/components/Loader";
import { getCookie } from "@/utils/cookies.js";
import { handleErrors, handleFormErrors } from "@/utils/errors.js";

export default {
  name: "Students",
  components: {
    pagination: Pagination,
    loader: Loader
  },
  data: function() {
    return {
      students: null,
      submitted: false,
      username: "",
      password1: "",
      password2: "",
      search: "",
      studentsNext: null,
      studentsPrevious: null,
      checkedStudents: [],
      signupLink: null,
      passphrase: null,
      updatedPassphrase: ""
    };
  },
  created: function() {
    if (this.$store.state.auth.account_type != "educator") {
      this.$router.push("/leagues");
      this.$store.commit("alert/addMessage", {
        message: `You do not have access to view that page.`,
        class: "warning",
        persist: false
      });
    } else {
      this.refreshStudents();
      this.getSignupLink();
    }
  },
  methods: {
    checkForTeam: function(teams, studentId) {
      let team = teams.find(function(team) {
        return team.owners.find(owner => owner.id == studentId) ? true : false;
      });
      return team;
    },
    updatePassphrase: function(e) {
      e.preventDefault();
      let app = this;
      const csrftoken = getCookie("csrftoken");

      let passphrase = new URLSearchParams({
        passphrase: app.updatedPassphrase
      });

      let status;

      fetch(
        `${process.env.VUE_APP_PLATFORM}/accounts/${
          app.$store.state.auth.user_id
        }/students/signup-link/`,
        {
          credentials: "include",
          method: "POST",
          mode: "cors",
          body: passphrase,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-CSRFToken": csrftoken
          }
        }
      )
        .then(function(response) {
          status = response.status;
          return response.json();
        })
        .then(function(response) {
          if (status == 200) {
            app.updatedPassphrase = "";
            app.passphrase = response.passphrase;
            app.$store.commit("alert/addMessage", {
              message: `Your passphrase was updated.`,
              class: "success",
              persist: false
            });
          } else {
            handleErrors(response.errors);
          }
        });
    },
    getSignupLink: function() {
      let app = this;

      let url = `${process.env.VUE_APP_PLATFORM}/accounts/${
        this.$store.state.auth.user_id
      }/students/signup-link/`;

      fetch(url, {
        credentials: "include",
        mode: "cors"
      })
        .then(function(response) {
          return response.json();
        })
        .then(function(response) {
          app.signupLink = response.url;
          app.passphrase = response.passphrase;
        });
    },
    editMultipleStudents: function(e) {
      e.preventDefault();
      let app = this;
      const csrftoken = getCookie("csrftoken");
      let url = `${process.env.VUE_APP_PLATFORM}/accounts/${
        this.$store.state.auth.user_id
      }/students/delete/`;

      let students = new URLSearchParams({
        users: app.checkedStudents
      });

      fetch(url, {
        credentials: "include",
        method: "POST",
        mode: "cors",
        body: students,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-CSRFToken": csrftoken
        }
      }).then(function(response) {
        if (response.status == 200 || response.status == 204) {
          app.refreshStudents();
          app.$store.commit("alert/addMessage", {
            message: `Your students have been updated.`,
            class: "success",
            persist: false
          });
        } else {
          app.$store.commit("alert/addMessage", {
            message: `Something went wrong. Please refresh and try again.`,
            class: "warning",
            persist: false
          });
        }
      });
    },
    searchStudents: function(e) {
      e.preventDefault();
      let app = this;
      this.students = null;

      let url = `${process.env.VUE_APP_PLATFORM}/accounts/${
        this.$store.state.auth.user_id
      }/students/?limit=20&search=${encodeURI(this.search)}`;

      fetch(url, {
        credentials: "include",
        mode: "cors"
      })
        .then(function(response) {
          return response.json();
        })
        .then(function(response) {
          app.studentsPrevious = response.previous;
          app.studentsNext = response.next;
          app.students = response.results;
        });
    },
    getStudents: function(url) {
      this.students = null;
      let app = this;
      let status;

      fetch(url, {
        credentials: "include",
        mode: "cors"
      })
        .then(function(response) {
          status = response.status;
          return response.json();
        })
        .then(function(response) {
          if (status == 200) {
            app.studentsPrevious = response.previous;
            app.studentsNext = response.next;
            app.students = response.results;
          } else {
            app.$store.commit("alert/addMessage", {
              message: `Unable to get students. Please refresh and try again.`,
              class: "danger",
              persist: false
            });
          }
        });
    },
    refreshStudents: function() {
      let url = `${process.env.VUE_APP_PLATFORM}/accounts/${
        this.$store.state.auth.user_id
      }/students/?limit=20`;

      this.getStudents(url);
    },
    createStudent: function(e) {
      let app = this;
      e.preventDefault();
      const csrftoken = getCookie("csrftoken");

      let form = new URLSearchParams({
        username: app.username,
        password1: app.password1,
        password2: app.password2
      });

      fetch(
        `${process.env.VUE_APP_PLATFORM}/accounts/${
          app.$store.state.auth.user_id
        }/students/`,
        {
          credentials: "include",
          method: "POST",
          mode: "cors",
          body: form,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-CSRFToken": csrftoken
          }
        }
      ).then(function(response) {
        if (response.status == 200) {
          app.username = "";
          app.password1 = "";
          app.password2 = "";

          app.refreshStudents();
          app.$store.commit("alert/addMessage", {
            message: `New student added!`,
            class: "success",
            persist: false
          });
        } else {
          response.json().then(function(result) {
            handleErrors(result.errors);
          });
        }
      });
    }
  }
};
</script>
